import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TarlV3JsonapiModule } from '®shared/tarl-v3-jsonapi';

import { ReadingListService } from './reading-list.service';

@NgModule({
  imports: [CommonModule, TarlV3JsonapiModule],
  providers: [ReadingListService],
})
export class ReadingListModule {}
